import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

interface NewModalProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const NewModal = (props: NewModalProps) => {
  const { title, description, children, open, onOpenChange } = props;

  const renderTitle = title ? <DialogTitle>{title}</DialogTitle> : null;

  const header =
    title || description ? <DialogHeader>{renderTitle}</DialogHeader> : null;

  const footer = props.footer ? (
    <DialogFooter>{props.footer}</DialogFooter>
  ) : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTitle className="sr-only">{description}</DialogTitle>
      <DialogContent className="sm:max-w-[425px]">
        {header}
        {children}
        {footer}
      </DialogContent>
    </Dialog>
  );
};

export default NewModal;
